import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { SITE_SPECIFIC_FACTORS } from "@/data/content";

const SITE_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/2bi53nqu_4b04ff2c-6312-4892-a8e0-bd79095ea973.png";

export const SiteSpecific = () => {
  const navigate = useNavigate();

  return (
    <section data-testid="site-specific-section" className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:mb-5 lg:px-12 lg:py-[56px]">
      <div className="lg:mx-auto lg:max-w-[1280px]">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -18 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <div className="h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]">
              <img
                src={SITE_IMAGE}
                alt="Greenhouse agricultural production facility"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 18 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-6"
          >
            <h2
              data-testid="site-specific-headline"
              className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
            >
              Built around your operation
            </h2>
            <p data-testid="site-specific-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
              A meaningful financial case requires actual operating information. An energy
              assessment uses this data to develop a preliminary system concept and identify
              whether further technical and financial evaluation is justified.
            </p>

            <div data-testid="site-specific-factors" className="mt-7 divide-y divide-borderLight border-t border-borderLight">
              {SITE_SPECIFIC_FACTORS.map((factor) => (
                <div key={factor} data-testid={`site-specific-factor-${factor}`} className="py-3.5">
                  <span className="text-sm text-ink">{factor}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 mb-[10px] sm:mb-0">
              <button
                type="button"
                data-testid="site-specific-cta-button"
                onClick={() => navigate("/#contact")}
                className="inline-flex h-11 items-center bg-teal text-white text-sm font-medium rounded-full px-6 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
              >
                Request a Farm Energy Assessment
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
